import { render, staticRenderFns } from "./DeliverList.vue?vue&type=template&id=2f7b2ff3&scoped=true"
import script from "./DeliverList.vue?vue&type=script&lang=js"
export * from "./DeliverList.vue?vue&type=script&lang=js"
import style0 from "./DeliverList.vue?vue&type=style&index=0&id=2f7b2ff3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b2ff3",
  null
  
)

export default component.exports